const sortOptions = {
  score: {
    label: 'Rating',
    field: ['score', 'pubdate'],
    order: ['desc', 'desc']
  },
  pubdate: {
    label: 'Most recent $$name$$',
    field: ['pubdate'],
    order: ['desc']
  },
  votes: {
    label: 'Most voted $$name$$',
    field: ['positiveVotes'],
    order: ['desc']
  },
  views: {
    label: 'Most viewed $$name$$',
    field: ['visitCount'],
    order: ['desc']
  },
  recent: {
    label: 'Newer $$name$$',
    field: ['createdAt'],
    order: ['desc']
  },
  recentFeeds: {
    label: 'Newer $$name$$',
    field: ['pubdate'],
    order: ['desc']
  },
  older: {
    label: 'Older $$name$$',
    field: ['createdAt'],
    order: ['asc']
  },
  unread: {
    label: 'Unread $$name$$',
    field: ['currentUser.visited', 'createdAt'],
    order: ['asc', 'desc']
  },
  priority: {
    label: 'Important',
    field: ['prioritySorter', 'createdAt'],
    order: ['desc', 'desc']
  },
  favorite: {
    label: 'Favorite',
    field: ['currentUser.favorited', 'createdAt'],
    order: ['desc', 'desc']
  },
  comment: {
    label: 'Last comments',
    field: ['lastComment', 'createdAt'],
    order: ['desc', 'desc']
  },
  activity: {
    label: 'Last activity',
    field: ['lastActivityAt'],
    order: ['desc']
  },
  title: {
    label: 'Title',
    field: ['title'],
    order: ['asc']
  },
  updated: {
    label: 'Recently updated',
    field: ['updatedAt'],
    order: ['asc']
  },
  fetched: {
    label: 'Last fetched',
    field: ['fetchedAt'],
    order: ['desc']
  },
  name: {
    label: 'Name',
    field: ['_name'],
    order: ['asc']
  },
  joined_new: {
    label: 'Newer Landscapes',
    field: ['joinedAt'],
    order: ['desc']
  },
  joined_old: {
    label: 'Older Landscapes',
    field: ['joinedAt'],
    order: ['asc']
  },
  favorite_landscape: {
    label: 'Favorite',
    field: ['favorite', '_name'],
    order: ['desc', 'asc']
  },
  role: {
    label: 'Role',
    field: ['currentUser._role', '_name'],
    order: ['desc', 'asc']
  }
}

export const orderOptions = (props, name) => {
  return Object.keys(sortOptions)
    .filter(key => props.includes(key))
    .map(key => {
      const option = Object.assign({}, sortOptions[key])
      option.label = option.label.replace('$$name$$', name)
      option.criteria = key
      return option
    })
    .sort((a, b) => props.indexOf(a.criteria) - props.indexOf(b.criteria))
}
/*
export const sortingTypes = props => {
  return Object.keys(sortOptions).reduce((dic, key) => {
    if (props.includes(key)) {
      dic[key] = sortOptions[key]
    }
    return dic
  }, {})
}
 */

export const getSorter = criteria => sortOptions[criteria] || sortOptions.recent
